export default __webpack_public_path__ + "static/media/toy3.39983dc0.jfif";